export enum InvoiceType {
  SDI = 'SDI',
  PEC = 'PEC',
}
